module.exports = __webpack_public_path__ + "img/cards.b0665ee2.png";